<template>
  <v-card>
    <v-container grid-list-lg class="pa-0">
      <v-card-title class="headline pb-0">
        Заголовок окна
        <v-spacer></v-spacer>
        <v-btn small icon class="mx-0" @click="$emit('close-dialog')">
          <v-icon class="mx-0">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-if="!editMode && showCode">
        <p class="mb-0">Вставьте этот код в то место, где должен отображаться драйвер</p>
        <code>{{htmlCode}}</code>
        <p class="mb-0 mt-4">Затем поместите следующий код внутри тега <b>head</b> или <b>body</b></p>
        <code>{{script}}</code>
      </v-card-text>
      <v-card-text v-else>
        <v-tabs slot="extension" v-model="tab" slider-color="accent" color="panel" dark>
          <v-tab href="#params">Параметры</v-tab>
          <v-tab href="#settings">Настройки</v-tab>
          <v-tab href="#scope">Область видимости</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item class="mt-2" id="params">
            <v-text-field v-validate="'required'" v-model="driver.name" :error-messages="veeErrors.collect('name')"
                          label="Название" data-vv-name="name" data-vv-as="'Название'" required
            ></v-text-field>
            <v-textarea v-model="driver.description" rows="3" label="Описание"></v-textarea>
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-select label="Тип" :items="all_types" v-model="driver.type" no-data-text="Отсутствуют значения"></v-select>
              </v-flex>
              <v-flex xs12 sm6>
                <v-select label="Объекты" :items="object_types" v-model="driver.object_type" no-data-text="Объекты отсутствуют"></v-select>
              </v-flex>
            </v-layout>
            
            <v-select label="Статистики" :items="statistics" v-model="driver.statistics" multiple item-text="name" item-value="id" no-data-text="Нет доступных статистик"></v-select>
          </v-tab-item>
          
          <v-tab-item class="mt-2" id="settings">
            <v-layout row wrap>
              <template v-if="driver.type===0">
                <v-flex xs12 md4>
                  <v-text-field v-model="driver.options.text" label="Текст"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="driver.options.width" label="Ширина" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="driver.options.height" label="Высота" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12 md4 class="mt-3">
                  <p class="pa-0 mt-1" style="float: left">Цвет фона: </p>
                  <div :style="{display:'inline-block', marginLeft:'10px', cursor: 'pointer' , width:'60px', height: '30px', background: driver.options.bgcolor || '#333' }" @click="showColors=(showColors==='bg')?false:'bg'"></div>
                  <swatches-picker v-show="showColors==='bg'" v-model="colors" @input="setColor('bg')"></swatches-picker>
                </v-flex>
                <v-flex xs12 md4 class="mt-3">
                  <p class="pa-0 mt-1" style="float: left">Цвет фона при наведении: </p>
                  <div :style="{display:'inline-block', marginLeft:'10px', cursor: 'pointer' , width:'60px', height: '30px', background: driver.options.hover || '#999'}" @click="showColors=(showColors==='hover')?false:'hover'"></div>
                  <swatches-picker v-show="showColors==='hover'" v-model="colors" @input="setColor('hover')"></swatches-picker>
                </v-flex>
                <v-flex xs12 md4 class="mt-3">
                  <p class="pa-0 mt-1" style="float: left">Цвет текста: </p>
                  <div :style="{display:'inline-block', marginLeft:'10px', cursor: 'pointer' , width:'60px', height: '30px', background: driver.options.color || '#C5C5C5'}" @click="showColors=(showColors==='text')?false:'text'"></div>
                  <swatches-picker v-show="showColors==='text'" v-model="colors" @input="setColor('text')"></swatches-picker>
                </v-flex>
                <v-flex xs12 md4>
                  <v-select label="Размер шрифта" :items="[12,14,16,18,20,24,28,32,40]" v-model="driver.options.size" no-data-text="Значения отсутствуют"></v-select>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="driver.options.value" label="Значение" type="number"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <p><b>Предпросмотр:</b></p>
                  <div @mouseenter="$event.target.style.background=driver.options.hover"
                       @mouseleave="$event.target.style.background=driver.options.bgcolor"
                    :style="{
                          cursor: 'pointer',
                          textAlign:'center',
                          fontSize:driver.options.size+'px',
                          width:driver.options.width+'px',
                          height:driver.options.height+'px',
                          lineHeight:driver.options.height+'px',
                          color: driver.options.color,
                          background:driver.options.bgcolor
                    }">{{driver.options.text}}</div>
                </v-flex>
              </template>
              <template v-else-if="driver.type===1">
                <v-flex xs12>
                  <v-text-field label="Заголовок формы"></v-text-field>
                </v-flex>
              </template>
            </v-layout>
          </v-tab-item>
          <v-tab-item class="mt-2" id="scope">
            <dantser-scope :treedata="treedata" v-model="driver.scope" withEdit withScopes></dantser-scope>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-card-actions class="pa-3" v-if="!showCode">
        <v-btn color="success" dark :disabled="status.btnDisabled" @click="submit">{{(editMode)?"Сохранить":"Сохранить и получить код"}}</v-btn>
        <span :class="status.className" class="ml-2">{{status.text}}</span>
      </v-card-actions>
    </v-container>
  </v-card>
  
</template>

<script>
  import {mapGetters} from 'vuex'
  import { Swatches } from 'vue-color'
  
  export default {
    name : "DriverForm",
  
    components:{
      'swatches-picker': Swatches
    },
    
    props:{
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          description: '',
          type: 0,
          object_type: 0,
          data: '',
          options: {},
          statistics: [],
          scope: []
        }}
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    
    computed:{
      ...mapGetters('analytics_old/indicators', ['indicators']),
    },
    
    data: () => ({
      tab: null,
      showCode: false,
      showColors: false,
      treedata: [],
      driver: {},
      all_types: [
        { value: 0, text: 'Кнопка' },
        { value: 1, text: 'Форма' },
      ],
      object_types:[
        { value: 0, text: 'Наследовать от статистик' },
        { value: 1, text: 'Записывать из драйвера' },
      ],
      colors: {
        hex: '#0288d1',
        hsl: {
          h: 201,
          s: 98,
          l: 41,
          a: 1
        },
        hsv: {
          h: 0.3470,
          s: 0.9853,
          v: 0.5333,
          a: 1
        },
        rgba: {
          r: 2,
          g: 136,
          b: 209,
          a: 1
        },
        a: 1
      },
      status:{
        btnDisabled: false,
        text: '',
        className:'green--text darken-1'
      },
      htmlCode: '',
      script: ''
    }),
  
    mounted(){
      this.driver = JSON.parse(JSON.stringify(this.data))
      this.getTree()
    },
    
    methods:{
      getTree(){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
        })
      },
  
      setColor(type){
        switch(type){
          case 'bg':
            this.driver.options.bgcolor = this.colors.hex
            break
          case 'hover':
            this.driver.options.hover = this.colors.hex
            break
          case 'text':
            this.driver.options.color = this.colors.hex
            break
        }
        this.showColors = false
      },
      
      submit(){
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.status={ btnDisabled: true, text: 'Сохранение', className:'grey--text lighten-1' }
            
            if(this.editMode){
              this.$store.dispatch('analytics_old/drivers/update', this.driver).then( response => {
                this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
                this.$emit('close-dialog')
              }).catch( error => {
                this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
              })
            } else {
              this.$store.dispatch('analytics_old/drivers/create', this.driver).then( response => {
                this.status={ btnDisabled: false, text: 'Сохранено', className:'green--text darken-1' }
                this.driver.id = response.id
                this.getCode(this.driver)
              }).catch( error => {
                this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
              })
            }
            return false
          } else {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'red--text darken-1' }
          }
        })
  
        return false
      },
      
      getCode(data){
        switch(data.type){
          case 0:
            this.htmlCode = '<div id="dms-btn-widget"></div>'
            this.script = '<script src="https://dev18.dantser.net/static/widgets/dmsButton.js?id='+data.id+'"><'+'/script>'
            break
        }
        this.showCode = true
      }
      
    },
    
    watch:{
      'driver.type'(val){
        switch(val){
          case 0:
            let options = {
              text: this.driver.options.text || '',
              width: this.driver.options.width || 100,
              height: this.driver.options.height || 100,
              bgcolor: this.driver.options.bgcolor || '#333',
              hover: this.driver.options.hover || '#999',
              color: this.driver.options.color || '#C5C5C5',
              size: this.driver.options.size || 20,
              value: this.driver.options.value || 1,
            }
            this.driver.options = options
            break
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics_old/components/Drivers/Forms/DriverForm.vue